import { Directive, EventEmitter, HostListener, OnDestroy, Output } from '@angular/core';
import { HelpService } from '@core/services/help.service';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[appHelpArticle]',
    standalone: true,
})
export class HelpArticleDirective implements OnDestroy {
    @Output() opened: EventEmitter<void> = new EventEmitter<void>();
    @Output() closed: EventEmitter<void> = new EventEmitter<void>();

    private showPanelSubscription: Subscription;

    constructor(private helpService: HelpService) {
        this.showPanelSubscription = this.helpService.showPanel$.subscribe((value) => {
            if (!value) {
                this.closed.emit();
            }
        });
    }

    @HostListener('click') public onOpenArticle() {
        this.helpService.openPanel();
        this.opened.emit();
    }

    ngOnDestroy() {
        this.showPanelSubscription.unsubscribe();
    }
}
